module.exports = __webpack_public_path__ + "img/agency_banner_4.9346c2a9.png";